<template>
  <div>
    <CrudList
      title="Tags"
      storeName="Tags"
      labelAddNew="Agregar nueva Tag"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      canSearch
    >
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
  };
</script>
